
export const userInfo=()=>{
    let userInfo = localStorage.getItem("userInfo");
    if(userInfo){
        userInfo = JSON.parse(userInfo);
    }
    return userInfo;
}